import { LooseObject } from '@gif/shared-global';
import { createSlice } from '@reduxjs/toolkit';

export interface BranchState {
  branchLink: string;
  branchData: LooseObject;
  isBranchLinkLoading: boolean;
  isBranchDataLoading: boolean;
}

const initialState: BranchState = {
  branchLink: '',
  branchData: {},
  isBranchLinkLoading: true,
  isBranchDataLoading: true,
};

export const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    setBranchLink: (state, action) => {
      state.branchLink = action.payload;
      state.isBranchLinkLoading = false;
    },
    setBranchInviteToGroupData: (state, action) => {
      state.branchData = { ...state.branchData, ...action.payload };
      state.isBranchDataLoading = false;
    },
    resetBranchLinkIsLoading: (state) => {
      state.isBranchLinkLoading = true;
    },
    resetBranchDataIsLoading: (state) => {
      state.isBranchDataLoading = true;
    },
  },
  reducerPath: 'branch',
});

// Action creators are generated for each case reducer function
export const {
  setBranchLink,
  setBranchInviteToGroupData,
  resetBranchLinkIsLoading,
  resetBranchDataIsLoading,
} = branchSlice.actions;

export default branchSlice;
